<div class="col-12 modal_container">
    <div class="col-12 text-center center">
        <h1>{{title}}</h1>
    </div>
    <div class="col-12 no-padding text-center-no-background">
        <p>{{text}}</p>
    </div>
    <div class="col-12 button-container">
        <div class="row">
            <div class="col-6 no-p-l">
                <button mcButton variant="closedialog" class="secondary-button" color="secondary" (click)="exit(false)">Annulla</button>
            </div>
            <div class="col-6 no-p-r">
                <button mcButton variant="confirmdialog" class="main-button" (click)="exit(true)">{{button}}</button>
            </div>
        </div>
    </div>
</div>
